import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import SelectForm from './SelectForm';

const style = theme => ({
	root: {

	}
})

function SelectCPV({
	classes,
	open,
	onConfirm,
	onCancel,
	initValues,
	label=Tr('cpv_code'),
	multiple = true
}) {
	const createInitCPV = () => initValues.reduce((obj, value) => {
		const {
			identity,
			publicCode,
			name,
			hierarchicalId,
		} = value;
		return {
			...obj,
			[JSON.stringify({
				identity,
				publicCode,
				name,
				hierarchicalId,
			})]: true,
		}
	}, {})

	return (
		<Dialog
			titleCentered
			title={label}
			open={open}
			maxWidth={'md'}
			onClose={onCancel}
		>
			<SelectForm
				onSubmit={onConfirm}
				onCancel={onCancel}
				initCPVValues={createInitCPV()}
				multiple={multiple}
			/>
		</Dialog>
	)
}

SelectCPV.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(SelectCPV);